import React, { useState } from "react";

import { Avatar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import { Formik } from "formik";
import { Dropdown } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import ArchiveIcon from "../../../assets/icons/archiveBlue.svg";
import Call from "../../../assets/icons/Call.svg";
import CSVIcon from "../../../assets/icons/CSV.svg";
import DeleteIcon from "../../../assets/icons/Delete.svg";
import editIcon from "../../../assets/icons/EditReport.svg";
import Email from "../../../assets/icons/Email.svg";
import Message from "../../../assets/icons/Message.svg";
import XLSIcon from "../../../assets/icons/XLS.svg";
import Archive from "../../../assets/media/svg/icons/Communication/Archive.svg";
import CallLight from "../../../assets/media/svg/icons/Communication/Call-light.svg";
import ExportIcon from "../../../assets/media/svg/icons/Files/Export-blue.svg";
import DropIcon from "../../../assets/media/svg/icons/General/Other1.svg";
import AngleRight from "../../../assets/media/svg/icons/Navigation/Angle-right.svg";
import { InputField, LabelField } from "../../../components";
import DatePickers from "../../../components/DatePicker/DatePicker";
import MyButton from "../../../components/MyButton";

//Styles
import "./styles.scss";

const usePlaceholderStyles = makeStyles((theme) => ({
  placeholder: {
    color: "#aaa",
  },
}));

const Placeholder = ({ children }) => {
  const classes = usePlaceholderStyles();
  return <div className={classes.placeholder}>{children}</div>;
};

const EditMember = ({
  feedAvatar,
  name,
  subtitle,
  description,
  color,
  status,
  month,
  data,
  onClick,
  EventData,
  setOpenEditMember,
}) => {
  const [successFull, setSuccessFul] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [updates, setUpdates] = useState([
    {
      id: uuidv4(),
      description:
        "Johan Mike already feels better Lorem ipsum dolor sit amet, consectetur adipiscing elit ut ",
    },
    {
      id: uuidv4(),
      description:
        "Johan Mike already feels better Lorem ipsum dolor sit amet, consectetur adipiscing elit ut ",
    },
    {
      id: uuidv4(),
      description:
        "Johan Mike already feels better Lorem ipsum dolor sit amet, consectetur adipiscing elit ut ",
    },
  ]);

  return (
    <div className="profile-drawer member-event-drawer p-5 edit-member">
      <div className="Scroll p-5">
        <div className="d-flex flex-column align-items-center">
          <Avatar alt={data.name} src={data.avtar} className="avtar"></Avatar>
          <h3 className="mt-5 name mb-0">{data.name}</h3>
        </div>
        <div>
          <Formik
            initialValues={{
              eventType: "",
              description: "",
              eventDate: "",
              eventStatus: "",
            }}
            validate={(values) => {
              const errors = {};
              if (!values.eventType) {
                //   errors.assignTo = "Required";
              }

              return errors;
            }}
            onSubmit={(values, actions) => {
              setSuccessFul(true);
              setLoading(true);
              setTimeout(() => {
                setLoading(false);
              }, 2000);
            }}
            handleChange={(e) => {
              console.log(e);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <>
                <div
                  className="form-group Account-name-newEvent  mt-5 h-100 "
                  style={{ width: "434px" }}
                >
                  <LabelField title={"Event Type"} />
                  <Select
                    className="assignTo-select editmember-select"
                    displayEmpty
                    value={values.eventType}
                    onChange={(e) => {
                      setFieldValue("eventType", e.target.value);
                    }}
                    renderValue={
                      values.eventType !== ""
                        ? undefined
                        : () => <Placeholder>Select Event</Placeholder>
                    }
                  >
                    {/* <MenuItem disabled value="">
                        <em>Select Name</em>
                      </MenuItem> */}
                    <MenuItem
                      value={"Robbi Ori Levi"}
                      className="d-flex justify w-100"
                    >
                      <span>Robbi Ori Levi</span>
                    </MenuItem>
                    <MenuItem value={10} className="d-flex justify w-100">
                      <span>Robbi Ori Levi</span>
                    </MenuItem>
                    <MenuItem value={10} className="d-flex justify w-100">
                      <span>Robbi Ori Levi</span>
                    </MenuItem>
                  </Select>
                </div>
                <div
                  className="mt-2 subjectField editmember-field"
                  style={{ width: "434px" }}
                >
                  <LabelField title={"Description"} />
                  <InputField
                    onChange={(e) => {
                      setFieldValue("description", e.target.value);
                    }}
                    {...{
                      name: "subject",
                      placeholder: "subject here",
                    }}
                  />
                </div>
                <div
                  className="from-group mb-10 editmember-field"
                  style={{ width: "434px" }}
                >
                  <LabelField title={"Event Date"} />
                  <DatePickers
                    className="addEvent-date"
                    onChange={(e) => setFieldValue("eventDate", e.target.value)}
                  />
                </div>
                <div
                  className="form-group Account-name-newEvent  editmember-field mt-5 h-100 "
                  style={{ width: "434px" }}
                >
                  <LabelField title={"Event Type"} />
                  <Select
                    className="assignTo-select editmember-select"
                    displayEmpty
                    value={values.eventStatus}
                    onChange={(e) => {
                      setFieldValue("eventStatus", e.target.value);
                    }}
                    renderValue={
                      values.eventStatus !== ""
                        ? undefined
                        : () => <Placeholder>Select status</Placeholder>
                    }
                  >
                    {/* <MenuItem disabled value="">
                        <em>Select Name</em>
                      </MenuItem> */}
                    <MenuItem value={"Active"} className="d-flex justify w-100">
                      <span className="text-success font-weight-bold">
                        Active
                      </span>
                    </MenuItem>
                    <MenuItem
                      value={"Cancelled"}
                      className="d-flex justify w-100"
                    >
                      <span className="text-warning font-weight-bold">
                        Cancelled
                      </span>
                    </MenuItem>
                    <MenuItem
                      value={" On-Hold"}
                      className="d-flex justify w-100"
                    >
                      <span className="text-danger font-weight-bold">
                        On-Hold
                      </span>
                    </MenuItem>
                  </Select>
                </div>

                <div
                  className="d-flex justify-content-between editmember-field"
                  style={{ width: "434px" }}
                >
                  <a
                    className="close-btn d-flex align-items-center"
                    onClick={() => setOpenEditMember(false)}
                  >
                    Close
                  </a>
                  <div className="saveBtn-drawer">
                    <MyButton
                      type={"primary"}
                      content={"Save"}
                      onClick={handleSubmit}
                      disabled={false}
                      variant="outlined"
                    />
                  </div>
                </div>
              </>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default EditMember;
